// @flow

import React from 'react';

import RowHeader from 'app/components/commons/RowHeader';

const RacingScoresDescription = () => (
  <RowHeader>
    Final scores will be based on the official National Tote dividends converted to points.
  </RowHeader>
);

export default RacingScoresDescription;
